// =========================================================
// * Vue Material Dashboard PRO - v1.4.0
// =========================================================
//
// * Product Page: https://toprate.io/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://toprate.io)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import VueExcelEditor from "vue-excel-editor";
import { initialize as initializeStore } from "@/store";
import KeycloakLib from "@/libs/Keycloak";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";

// router setup
import routerConfig from "./routes";

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueExcelEditor);

// global library setup
Vue.prototype.$Chartist = Chartist;

Vue.config.errorHandler = (err, vm, info) => {
  // Show any error but this one
  if (!err.message.includes("reading 'badInput'")) {
    console.error(err);
  }
};
// Import Global Libraries
import "./globalLibraries";
import { abilitiesPlugin } from "@casl/vue";

import i18n from "@/lang/i18n";
import { receiveMessage } from "./helpers/firebase";

KeycloakLib.initKeycloak(() => {
  const storeIns = initializeStore();

  const currentSub = KeycloakLib.getUser()?.sub;
  const storedSub = localStorage.getItem('kc_sub');
  
  if (storedSub && currentSub && storedSub !== currentSub) {
     storeIns.dispatch('schoolAuth/Logout');
     storeIns.dispatch('user/ClearUserInfo');
  }
  
  if (currentSub) {
     localStorage.setItem('kc_sub', currentSub);
  }

  Vue.use(abilitiesPlugin, storeIns.getters["user/abilities"]);
  receiveMessage();

  new Vue({
    el: "#app",
    store: storeIns,
    render: h => h(App),
    router: routerConfig,
    i18n
  });
});
